module.exports = __webpack_public_path__ + "static/media/link-expired.6c9fd57d.png";